import { Link } from 'react-router-dom';

import { Icon } from '@/components/icon';
import { Logo } from '@/components/logo';
import { company } from '@/data/company';

const yearNow = new Date().getFullYear();

const linkColumns = [
  {
    title: 'Leistungen',
    links: [
      { to: '/baumpflege', label: 'Baumpflege' },
      { to: '/baumhausbau', label: 'Baumhausbau' },
      { to: '/baumfaellung', label: 'Baumfällung & Wurzeln' },
      { to: '/baumpflege/sturmschaeden', label: 'Sturmschäden' },
    ],
  },
  {
    title: 'Unternehmen',
    links: [
      { to: '/ueber-uns', label: 'Über uns' },
      { to: '/referenzen', label: 'Referenzen' },
      { to: '/einsatzgebiet', label: 'Einsatzgebiet' },
      { to: '/kontakt', label: 'Kontakt' },
    ],
  },
  {
    title: 'Rechtliches',
    links: [
      { to: '/impressum', label: 'Impressum' },
      { to: '/datenschutz', label: 'Datenschutz' },
    ],
  },
];

export function Footer(): React.ReactNode {
  return (
    <footer className="bg-bark text-paper">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" aria-label="Zur Startseite">
              <Logo variant="light" className="h-10 w-auto" />
            </Link>
            <address className="mt-4 not-italic text-paper/80">
              {company.address.street}
              <br />
              {company.address.postalCode} {company.address.city}
            </address>
            <div className="mt-4 space-y-2 text-sm text-paper/80">
              <a href={company.phone.href} className="flex items-center gap-2 hover:text-paper">
                <Icon name="Phone" className="h-4 w-4" />
                {company.phone.display}
              </a>
              <a href={company.email.href} className="flex items-center gap-2 hover:text-paper">
                <Icon name="Mail" className="h-4 w-4" />
                {company.email.primary}
              </a>
            </div>
          </div>
          {linkColumns.map((column) => (
            <div key={column.title}>
              <h3 className="mb-4 text-sm font-semibold uppercase tracking-wide text-paper/60">
                {column.title}
              </h3>
              <ul className="space-y-2 text-paper/80">
                {column.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="hover:text-paper">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 border-t border-paper/10 pt-6 text-sm text-paper/60">
          © {String(yearNow)} {company.name}. Einsatzgebiet: {company.serviceArea}.
        </div>
      </div>
    </footer>
  );
}
